import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from '@careinfo/permission-required';
import DarazOrderList from '../pages/DarazOrder/DarazOrderList';
import CreateDarazOrder from '../pages/DarazOrder/CreateDarazOrder';
import EditDarazOrder from '../pages/DarazOrder/EditDarazOrder';

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path='/' element={<DarazOrderList />} />
          <Route path='/daraz-orders' element={<DarazOrderList />} />
          <Route path='/create' element={<CreateDarazOrder />} />
          <Route path='/edit/:id' element={<EditDarazOrder />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
